const initTooltip = (tooltip: HTMLElement) => {
    if (!tooltip.dataset.originalContent) {
        tooltip.dataset.originalContent = tooltip.dataset.content;
    }

    const icon = tooltip.querySelector('i.fa');
    if (icon) {
        icon.classList.add('hidden');
    }
    tooltip.dataset.content = `${tooltip.parentElement.innerHTML}<div>${tooltip.dataset.originalContent}</div>`;
    if (icon) {
        icon.classList.remove('hidden');
    }
};

const restoreTooltip = (tooltip: HTMLElement) => {
    if (tooltip.dataset.originalContent) {
        tooltip.dataset.content = tooltip.dataset.originalContent;
    }
};

const getTooltip = (el: HTMLElement) => el.querySelector<HTMLElement>('div,span[data-toggle="popover"][data-content]');

const initPopover = (el: HTMLElement) => {
    const tooltip = getTooltip(el);
    if (tooltip) {
        initTooltip(tooltip);
        return;
    }

    el.dataset.content = el.innerHTML;
    el.dataset.html = 'true';
    el.dataset.placement = 'top';
    el.dataset.toggle = 'popover';
    el.dataset.trigger = 'click';
    el.classList.add('hover');
    wo$(el).popover();
};

const restorePopover = (el: HTMLElement) => {
    wo$(el).popover('hide');

    const tooltip = getTooltip(el);
    if (tooltip) {
        restoreTooltip(tooltip);
        return;
    }

    wo$(el).popover('destroy');
    el.classList.remove('hover');
};

const onResize = (el: HTMLElement) => {
    const hasOverflow = el.clientHeight < el.scrollHeight;
    if (hasOverflow) {
        initPopover(el);
    } else {
        restorePopover(el);
    }
};

const observer = new ResizeObserver(entries => {
    for (const entry of entries) {
        onResize(entry.target as HTMLElement);
    }
});

const observeResize = () => {
    const items = document.querySelectorAll<HTMLElement>('[data-widget-type="hero-campaign"] .text-truncate-2');
    for (const item of Array.from(items)) {
        observer.observe(item);
    }

    window.addEventListener('unload', () => observer.disconnect());
};

const init = () => {
    observeResize();
};

function main() {
    WhistleOut.initWidget = init;
    init();
}

WhistleOut.initModule(import.meta.url, main);
